const titleCase = (input: string): string => (input.length > 0 ? input.replace(input[0], input[0].toUpperCase()) : '');

export { titleCase };
